<template>
  <div v-if="showHeaderMenuAndFooter">
    <div class="wrapper">
      <menu-header />
      <div class="page-wrap">
        <menu-sidebar
          @open-tutorial-google-datastudio="openTutorialGoogleDataStudio"
          @open-tutorial-webphone="openTutorialWebphone" />
        <div class="main-content">
          <div class="container-fluid">
            <slot/>
          </div>
        </div>
        <footer class="footer">
          <div class="w-100 clearfix">
            <span class="text-center text-sm-left d-md-inline-block">Copyright © 2019 Api4Com. All Rights Reserved.</span>
            <span class="float-none float-sm-right mt-1 mt-sm-0 text-center">
              Developed <i class="ik ik-heart-on text-danger" /> by
              <a
                href="https://www.api4com.com"
                class="text-dark"
                target="_blank">Api4Com</a>
              Team
            </span>
          </div>
        </footer>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="tutorialGoogleDataStudio"
      ref="tutorialGoogleDataStudio"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered modal-lg"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Tutorial Google Data Studio</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <h1>
              Para acessar o Google Data Studio
              <a
                class="link"
                href="https://datastudio.google.com/"
                target="_blank">
                clique aqui
              </a>.
            </h1>
            <iframe
              width="760"
              height="420"
              src="https://www.youtube.com/embed/sqVf3CEbrIQ"
              title="Tutorial Google Data Studio"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" />
          </div>
          <div class="modal-footer" />
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="tutorialWebphone"
      ref="tutorialWebphone"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered modal-lg"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Tutorial Webphone</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <h1>
              Para instalar o Webphone
              <a
                class="link"
                href="https://chrome.google.com/webstore/detail/api4com-extens%C3%A3o-para-nav/nmihkcakhpccmdhoifppbgeoapjaanno?hl=pt-BR"
                target="_blank">
                clique aqui
              </a>
            </h1>
            <iframe
              width="760"
              height="420"
              src="https://www.youtube.com/embed/rBlGNryfRhU?start=73"
              title="Tutorial Webphone"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" />
          </div>
          <div class="modal-footer" />
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="modalBonusCredit"
      ref="modalBonusCredit"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered modal-small"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Seja muito bem-vindo!</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <h1>
              Ative Crédito Bônus de R$5,00 Agora!
            </h1>
            <p class="text-first-access">
              Complete a validação do seu CNPJ/CPF para desbloquear um bônus exclusivo de R$5,00 na sua conta.
            </p>
            <p class="text-first-access">
              Valide seu dados
              <a
                class="link"
                href="#"
                @click.prevent="redirectToFinancialData">
                clicando aqui
              </a>
            </p>
            <p class="footer-first-access">
              <a
                class="link"
                href="#"
                @click.prevent="ignoreNotificationBonusCredit">
                Ignorar notificação e acessar o sistema
              </a>
            </p>
          </div>
          <div class="modal-footer" />
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="auth-wrapper">
      <div class="container-fluid h-100">
        <div class="row flex-row h-100 bg-white">
          <div class="col-xl-8 col-lg-6 col-md-5 p-0 d-md-block d-lg-block d-sm-none d-none">
            <div
              class="lavalite-bg"
              style="background-image: url('/static/images/dashOnMac.png')">
              <div class="lavalite-overlay" />
            </div>
          </div>
          <div class="col-xl-4 col-lg-6 col-md-7 my-auto p-0">
            <div class="authentication-form mx-auto">
              <div class="logo-centered">
                <img
                  src="/static/images/logo_small.png"
                  alt="Api4Com - API de VOZ integrado com seu CRM"
                  title="Api4Com - API de VOZ integrado com seu CRM">
              </div>
              <slot/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MenuHeader from '@/components/Container/MenuHeader'
import MenuSidebar from '@/components/Container/MenuSidebar'

export default {
  name: 'Container',
  components: {
    MenuHeader,
    MenuSidebar
  },
  props: {
    showHeaderMenuAndFooter: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      isAdminBonusCreditNotified: false
    }
  },
  updated () {
    this.$nextTick(() => {
      this.showNotificationBonusCredit()
    })
  },
  methods: {
    openTutorialGoogleDataStudio () {
      $(this.$refs.tutorialGoogleDataStudio).modal('show')
    },
    openTutorialWebphone () {
      $(this.$refs.tutorialWebphone).modal('show')
    },
    redirectToFinancialData () {
      $(this.$refs.modalBonusCredit).modal('hide')
      if (this.$router.currentRoute.name === 'financialData') return
      this.$router.push({ name: 'financialData' })
    },
    ignoreNotificationBonusCredit () {
      this.saveLocalStorage('ignoreNotificationBonusCredit', true)
      $(this.$refs.modalBonusCredit).modal('hide')
    },
    saveLocalStorage (key, value) {
      localStorage.setItem(key, value)
    },
    getLocalStorage (key) {
      return localStorage.getItem(key)
    },
    showNotificationBonusCredit () {
      if (this.isAdminBonusCreditNotified) return
      if (Boolean(JSON.parse(this.getLocalStorage('ignoreNotificationBonusCredit'))) === true) return
      if (!this.$store.state.auth.user) return
      if (!this.$store.state.auth.organization) return
      if (this.$store.state.auth.user.role === 'ADMIN') {
        if (
          this.$store.state.auth.softswitchIntegration &&
          this.$store.state.auth.softswitchIntegration.metadata &&
          this.$store.state.auth.softswitchIntegration.metadata.receivedBonusCredit === false
        ) {
          $(this.$refs.modalBonusCredit).modal('show')
        }
      }
      this.isAdminBonusCreditNotified = true
    }
  },
  watch: {
    '$store.state.auth.user': function () {
      this.showNotificationBonusCredit()
    }
  }
}
</script>

<style lang="scss">
.auth-wrapper {
  .lavalite-bg {
    .lavalite-overlay {
      background: linear-gradient(135deg,rgba(3, 55, 122, 0.281) 0%,rgba(44, 142, 255, 0.466) 100%);
    }
  }
}
.text-first-access {
  font-size: 1.1rem;
  margin-top: 2rem;
  margin-bottom: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Container.vue